import { Component, OnInit, OnDestroy, ViewChild, ElementRef, DoCheck, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SidenavService } from 'src/app/services/sidenav.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import { Customerservice } from 'src/app/model/customerservice.model';
import { CustomergroupService } from 'src/app/services/customergroup.service';

@Component({
  standalone: false,
  selector: 'app-create-service-group',
  templateUrl: './create-service-group.component.html',
  styleUrls: ['./create-service-group.component.scss']
})
export class CreateServiceGroupComponent implements OnInit, OnDestroy {

  public customerservice = new Customerservice();
  private subscriptions = new Subscription();

  prakList: any = [];
  public formData: any;
  finalSubmissionArray = [];

  activeIds: string[] = ['form_row_01', 'form_row_02', 'form_row_03'];

  myForm!: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private sideNavService: SidenavService,
    private appStateSrv: AppStateProvider,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private acroute: ActivatedRoute,
    private customergroupService: CustomergroupService,
  ) {
    this.myForm = this.formBuilder.group({
      groupName: this.formBuilder.array([this.newNotes()]),
      createdBy: '',
      isActive: true,
    });

    localStorage.setItem('expandNavUser', 'true');
    const route = this.sideNavService.routingChunks({
      name: 'Users',
      subNav: '0',
      subNavLink: '',
    });
    this.appStateSrv.setSideNavState(route);
  }

  ngOnInit(): void {
    localStorage.removeItem('expandNav');
    localStorage.removeItem('expandNavLand');
  }

  ngOnDestroy() {
    localStorage.removeItem('expandNavUser');
    this.subscriptions.unsubscribe();
  }

  groupName(): FormArray {
    return this.myForm.get('groupName') as FormArray;
  }

  newNotes(): FormGroup {
    return this.formBuilder.group({
      addgroupname: ['', Validators.required],
    });
  }

  addMore(): void {
    this.groupName().push(this.newNotes());
  }

  removeBlock(i: number) {
    this.groupName().removeAt(i);
  }

  getParkDetails() {
    this.customergroupService.getParkByCLAId().subscribe((res) => {
      if (res.isValid) {
        this.prakList = res.list;
      }
    });
  }

  onSubmit() {

    this.finalSubmissionArray = [];
    for (let i = 0; i <= this.myForm.value.groupName.length - 1; i++) {
      this.finalSubmissionArray.push({
        'customerServiceGroupName': this.myForm.value.groupName[i].addgroupname,
        'createdBy': localStorage.getItem('claAdminId'),
        'isActive': true
      });
    }

    if (this.myForm.valid) {
      this.customergroupService
        .createCustomerUserServiceGroup(this.finalSubmissionArray)
        .subscribe((res) => {
          if (res?.isValid === true) {
            this.router.navigate(['/list-service-group/']);
          }
        });
    } else {
      this.myForm.markAllAsTouched();
    }
  }

  goToListPage() {
    this.router.navigate(['/list-service-group/']);
  }

}
